import { render, staticRenderFns } from "./customerNSales.vue?vue&type=template&id=b7425958"
import script from "./customerNSales.vue?vue&type=script&lang=js"
export * from "./customerNSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports